/* سمسم ورلد – سكريبت الهيدر (القايمة والحساب والبحث القديم) */
(function () {
    'use strict';
    var C = window.SMSM_HDR || {};

    var root = document.querySelector('[data-smsm-header]');
    if (!root) return;

    var drawer = root.querySelector('[data-smsm-drawer]');
    var overlay = root.querySelector('[data-smsm-overlay]');
    var openBtn = root.querySelector('[data-smsm-open]');
    var accountBtn = root.querySelector('[data-smsm-account]');
    var wishlistBadge = root.querySelector('[data-smsm-wishlist-badge]');
    var closeTimer = null;
    var wishlistObserver = null;

    function setupWishlistCounter() {
      if (!wishlistBadge) return;

      var wishlistLinks = document.querySelectorAll('a[href*="/pages/wishlist"]');
      var nativeWishlistLink = null;

      for (var i = 0; i < wishlistLinks.length; i++) {
        var link = wishlistLinks[i];

        if (!root.contains(link) && /\d+/.test(link.textContent || '')) {
          nativeWishlistLink = link;
          break;
        }
      }

      if (!nativeWishlistLink) {
        wishlistBadge.textContent = '0';
        wishlistBadge.setAttribute('aria-label', '0 wishlist items');
        return;
      }

      function updateWishlistBadge() {
        var text = String(nativeWishlistLink.textContent || '');
        var match = text.match(/\d+/);
        var count = match ? parseInt(match[0], 10) : 0;

        if (isNaN(count) || count < 0) count = 0;

        wishlistBadge.textContent = String(count);
        wishlistBadge.setAttribute('aria-label', count + ' wishlist items');
      }

      updateWishlistBadge();

      wishlistObserver = new MutationObserver(updateWishlistBadge);
      wishlistObserver.observe(nativeWishlistLink, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupWishlistCounter, { once: true });
    } else {
      setupWishlistCounter();
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function openDrawer(useOverlay) {
      if (!drawer) return;

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');

      if (overlay && useOverlay) {
        overlay.classList.add('is-open');
      }
    }

    function closeDrawer() {
      if (!drawer) return;

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      if (overlay) {
        overlay.classList.remove('is-open');
      }
    }

    function delayedClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeDrawer, 160);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    if (openBtn) {
      openBtn.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        cancelClose();
        openDrawer(false);
      });

      openBtn.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        delayedClose();
      });

      openBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (drawer && drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer(!isDesktop());
        }
      });
    }

    if (drawer) {
      drawer.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        cancelClose();
      });

      drawer.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        delayedClose();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    root.querySelectorAll('.smsm-sub-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var li = btn.closest('li');
        if (!li) return;

        li.classList.toggle('is-open');

        var plus = btn.querySelector('.smsm-toggle-plus');
        if (plus) {
          plus.textContent = li.classList.contains('is-open') ? '−' : '+';
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (root.contains(event.target)) return;

      closeDrawer();

      root.querySelectorAll('[data-smsm-results]').forEach(function (box) {
        box.classList.remove('is-open');
      });
    });

    if (accountBtn && C.acc) {
      accountBtn.addEventListener('click', function (event) {
        var selectors = [
          '[data-login-show]',
          '[data-action="login"]',
          '[data-action="open-login"]',
          '[data-open-login]',
          '[data-login-popup]',
          '.js-login-popup',
          '.login-popup-toggle',
          '.account-popup-toggle',
          '.header__account [data-popup]',
          '.customer-login-popup'
        ];

        var popupTrigger = null;

        selectors.some(function (selector) {
          var element = document.querySelector(selector);

          if (element && !root.contains(element)) {
            popupTrigger = element;
            return true;
          }

          return false;
        });

        if (popupTrigger) {
          event.preventDefault();
          popupTrigger.click();
        }
      });
    }

    var animationFrame = 0;
    var mobileCollapsed = root.classList.contains('smsm-mobile-scrolled');
    var requestFrame = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 16);
    };

    function updateMobileHeader() {
      if (animationFrame) return;

      animationFrame = requestFrame(function () {
        animationFrame = 0;

        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        var shouldCollapse = isMobile && (
          mobileCollapsed ? scrollTop > 35 : scrollTop > 100
        );

        if (shouldCollapse === mobileCollapsed) return;

        mobileCollapsed = shouldCollapse;
        root.classList.toggle('smsm-mobile-scrolled', shouldCollapse);
      });
    }

    updateMobileHeader();
    window.addEventListener('scroll', updateMobileHeader, { passive: true });
    window.addEventListener('resize', updateMobileHeader, { passive: true });

    var forms = root.querySelectorAll('[data-smsm-search]');
    var activeController = null;
    var debounceTimer = null;
    var searchCache = Object.create(null);
    var cacheKeys = [];
    var MIN_SEARCH_CHARS = Math.max(Number(C.min) || 2, 2);
    var SEARCH_DEBOUNCE_MS = 250;
    var LIVE_SEARCH_LIMIT = Math.min(
      Math.max(Number(C.lim) || 10, 4),
      10
    );
    var moneyFormat = C.money;

    var strings = {
      loading: (C.ar ? 'جاري البحث...' : 'Searching...'),
      empty: (C.ar ? 'لا توجد منتجات مطابقة' : 'No matching products'),
      error: (C.ar ? 'تعذر تحميل النتائج الآن' : 'Could not load results now')
    };

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        }[character];
      });
    }

    function shopRoot() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root.replace(/\/$/, '');
      }

      return '';
    }

    function formatPrice(value) {
      if (value === null || value === undefined || value === '') return '';

      if (typeof value === 'string') {
        return value.replace(/<[^>]*>?/gm, '');
      }

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(value, moneyFormat);
      }

      return value;
    }

    function getProductImage(product) {
      if (!product) return '';

      if (typeof product.image === 'string') {
        return product.image;
      }

      if (product.image && product.image.url) {
        return product.image.url;
      }

      if (product.image && product.image.src) {
        return product.image.src;
      }

      if (typeof product.featured_image === 'string') {
        return product.featured_image;
      }

      if (product.featured_image && product.featured_image.url) {
        return product.featured_image.url;
      }

      return '';
    }

    function resultHtml(products) {
      if (!products || !products.length) {
        return '<div class="smsm-suggest-state">' + strings.empty + '</div>';
      }

      return products.map(function (product) {
        var image = getProductImage(product);
        var price = formatPrice(product.price);
        var imageHtml = image
          ? '<img class="smsm-suggest-img" src="' + escapeHtml(image) + '" width="56" height="56" alt="' + escapeHtml(product.title) + '" loading="lazy" decoding="async">'
          : '<span class="smsm-suggest-img" aria-hidden="true"></span>';

        return (
          '<a class="smsm-suggest-item" href="' + escapeHtml(product.url || '#') + '">' +
            imageHtml +
            '<span>' +
              '<span class="smsm-suggest-title">' + escapeHtml(product.title) + '</span>' +
              (price ? '<span class="smsm-suggest-price">' + escapeHtml(price) + '</span>' : '') +
            '</span>' +
          '</a>'
        );
      }).join('');
    }

    function normalizePredictiveProducts(data) {
      if (
        !data ||
        !data.resources ||
        !data.resources.results ||
        !data.resources.results.products
      ) {
        return [];
      }

      return data.resources.results.products.map(function (product) {
        return {
          title: product.title || '',
          url: product.url || '#',
          image: getProductImage(product),
          price: product.price || product.compare_at_price || ''
        };
      });
    }

    function parseSearchPageProducts(html, limit) {
      var parser = new DOMParser();
      var documentFragment = parser.parseFromString(html, 'text/html');
      var products = [];
      var seen = {};
      var links = documentFragment.querySelectorAll('a[href*="/products/"]');

      links.forEach(function (link) {
        if (products.length >= limit) return;

        var href = link.getAttribute('href') || '';
        if (!href || seen[href]) return;

        var card = link.closest(
          '.card, .product-card, .product-item, .grid__item, li, article, [class*="product"]'
        ) || link;
        var imageElement = card.querySelector('img') || link.querySelector('img');
        var titleElement = card.querySelector(
          '.card__heading, .product-title, .product-item__title, [class*="title"], h3, h2'
        ) || link;
        var priceElement = card.querySelector('.price, [class*="price"], .money');
        var imageSource = '';

        if (imageElement) {
          imageSource =
            imageElement.getAttribute('src') ||
            imageElement.getAttribute('data-src') ||
            imageElement.getAttribute('data-original') ||
            '';

          if (!imageSource && imageElement.getAttribute('srcset')) {
            imageSource = imageElement
              .getAttribute('srcset')
              .split(',')[0]
              .trim()
              .split(' ')[0];
          }
        }

        if (imageSource && imageSource.indexOf('//') === 0) {
          imageSource = window.location.protocol + imageSource;
        }

        var title = titleElement ? titleElement.textContent.trim() : '';
        var price = priceElement
          ? priceElement.textContent.replace(/\s+/g, ' ').trim()
          : '';

        if (!title && imageElement) {
          title = imageElement.getAttribute('alt') || '';
        }

        if (!title) return;

        seen[href] = true;

        products.push({
          title: title,
          url: href,
          image: imageSource,
          price: price
        });
      });

      return products;
    }

    function fetchPredictive(query, signal) {
      var url =
        shopRoot() +
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=' +
        LIVE_SEARCH_LIMIT +
        '&resources[options][unavailable_products]=show' +
        '&resources[options][prefix]=last' +
        '&resources[options][fields]=title,body,product_type,variants.title,variants.sku,vendor,tag';

      return fetch(url, {
        headers: { Accept: 'application/json' },
        signal: signal
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Predictive search failed');
          }

          return response.json();
        })
        .then(normalizePredictiveProducts);
    }

    function fetchSearchPage(query, signal) {
      var url =
        shopRoot() +
        '/search?q=' +
        encodeURIComponent(query) +
        '&type=product' +
        '&options%5Bprefix%5D=last';

      return fetch(url, {
        headers: { Accept: 'text/html' },
        signal: signal
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Search page failed');
          }

          return response.text();
        })
        .then(function (html) {
          return parseSearchPageProducts(html, LIVE_SEARCH_LIMIT);
        });
    }

    function normalizeSearchText(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[ًٌٍَُِّْـ]/g, '')
        .replace(/[أإآٱ]/g, 'ا')
        .replace(/[ىي]/g, 'ي')
        .replace(/[ة]/g, 'ه')
        .replace(/[ؤ]/g, 'و')
        .replace(/[ئء]/g, '')
        .replace(/[^\p{L}\p{N}\s]/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function splitSearchWords(value) {
      var clean = normalizeSearchText(value);
      return clean ? clean.split(' ') : [];
    }

    function uniqueProducts(products) {
      var seen = {};
      var unique = [];

      (products || []).forEach(function (product) {
        if (!product) return;

        var key = product.url && product.url !== '#'
          ? product.url
          : normalizeSearchText(product.title);

        if (!key || seen[key]) return;

        seen[key] = true;
        unique.push(product);
      });

      return unique;
    }

    function productMatchesSearch(product, cleanQuery, queryWords) {
      var title = normalizeSearchText(product.title);
      var url = normalizeSearchText(product.url);
      var text = title + ' ' + url;

      if (text.indexOf(cleanQuery) !== -1) return true;

      return queryWords.every(function (word) {
        return text.indexOf(word) !== -1;
      });
    }

    function scoreSearchProduct(product, cleanQuery, queryWords) {
      var title = normalizeSearchText(product.title);
      var score = 0;

      if (title === cleanQuery) {
        score += 300;
      } else if (title.indexOf(cleanQuery) === 0) {
        score += 220;
      } else if (title.indexOf(cleanQuery) !== -1) {
        score += 180;
      }

      queryWords.forEach(function (word) {
        if (title.indexOf(word) === 0) {
          score += 80;
        } else if (title.indexOf(' ' + word) !== -1) {
          score += 65;
        } else if (title.indexOf(word) !== -1) {
          score += 45;
        }
      });

      return score;
    }

    function sortAndFilterProducts(query, products, limit) {
      var cleanQuery = normalizeSearchText(query);
      var queryWords = splitSearchWords(query);
      var unique = uniqueProducts(products);

      if (!cleanQuery || !queryWords.length) return unique.slice(0, limit);

      var matched = unique.filter(function (product) {
        return productMatchesSearch(product, cleanQuery, queryWords);
      });

      if (!matched.length) {
        matched = unique;
      }

      matched.sort(function (first, second) {
        return (
          scoreSearchProduct(second, cleanQuery, queryWords) -
          scoreSearchProduct(first, cleanQuery, queryWords)
        );
      });

      return matched.slice(0, limit);
    }

    function cacheResults(query, products) {
      if (!Object.prototype.hasOwnProperty.call(searchCache, query)) {
        cacheKeys.push(query);
      }

      searchCache[query] = products;

      if (cacheKeys.length > 30) {
        delete searchCache[cacheKeys.shift()];
      }
    }

    function renderSearchResults(query, products, box, input) {
      if (input && input.value.trim() !== query) return;

      products = products || [];
      cacheResults(query, products);
      box.innerHTML = resultHtml(products);
      box.classList.add('is-open');
    }

    function searchProducts(query, box, input) {
      if (!box) return;

      query = String(query || '').trim();

      if (query.length < MIN_SEARCH_CHARS) {
        if (activeController) activeController.abort();

        box.classList.remove('is-open');
        box.innerHTML = '';
        return;
      }

      if (Object.prototype.hasOwnProperty.call(searchCache, query)) {
        box.innerHTML = resultHtml(searchCache[query]);
        box.classList.add('is-open');
        return;
      }

      box.innerHTML = '<div class="smsm-suggest-state">' + strings.loading + '</div>';
      box.classList.add('is-open');

      if (activeController) activeController.abort();

      activeController = new AbortController();
      var currentController = activeController;

      Promise.all([
        fetchPredictive(query, currentController.signal).catch(function () {
          return [];
        }),
        fetchSearchPage(query, currentController.signal).catch(function () {
          return [];
        })
      ])
        .then(function (groups) {
          if (currentController.signal.aborted) return;

          var combined = []
            .concat(groups[0] || [])
            .concat(groups[1] || []);

          var products = sortAndFilterProducts(
            query,
            combined,
            LIVE_SEARCH_LIMIT
          );

          renderSearchResults(query, products, box, input);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (input && input.value.trim() !== query) return;

          box.innerHTML = '<div class="smsm-suggest-state">' + strings.error + '</div>';
          box.classList.add('is-open');
        });
    }

    forms.forEach(function (form) {
      var input = form.querySelector('[data-smsm-input]');
      var box = form.parentElement.querySelector('[data-smsm-results]');
      var isComposing = false;

      if (!input || !box) return;

      function handleSearchInput() {
        var query = input.value.trim();

        clearTimeout(debounceTimer);

        if (query.length < MIN_SEARCH_CHARS) {
          if (activeController) activeController.abort();

          box.classList.remove('is-open');
          box.innerHTML = '';
          return;
        }

        if (Object.prototype.hasOwnProperty.call(searchCache, query)) {
          box.innerHTML = resultHtml(searchCache[query]);
          box.classList.add('is-open');
          return;
        }

        debounceTimer = setTimeout(function () {
          searchProducts(query, box, input);
        }, SEARCH_DEBOUNCE_MS);
      }

      input.addEventListener('compositionstart', function () {
        isComposing = true;
      });

      input.addEventListener('compositionend', function () {
        isComposing = false;
        handleSearchInput();
      });

      input.addEventListener('input', function () {
        if (isComposing) return;
        handleSearchInput();
      });

      input.addEventListener('focus', function () {
        var query = input.value.trim();

        if (query.length < MIN_SEARCH_CHARS) return;

        if (box.innerHTML.trim()) {
          box.classList.add('is-open');
        } else {
          handleSearchInput();
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      closeDrawer();

      root.querySelectorAll('[data-smsm-results]').forEach(function (box) {
        box.classList.remove('is-open');
      });
    });
  })();
